// Import model
import { MaterialAssignmentCondition } from '../models/MaterialAssignmentCondition';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { ApiPiConditionOperator } from '../models/ApiPiConditionOperator';
import { MaterialAssignmentIndexedFields } from '../models/MaterialAssignmentIndexedFields';

// Import dependency serializers (for complex types)
import { ApiPiConditionOperatorSerializer } from './ApiPiConditionOperatorSerializer';
import { MaterialAssignmentIndexedFieldsSerializer } from './MaterialAssignmentIndexedFieldsSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for MaterialAssignmentCondition - handles JSON serialization and deserialization with type validation
 */
export class MaterialAssignmentConditionSerializer {
  /**
   * Deserializes a JSON string into a MaterialAssignmentCondition instance
   */
  static deserialize(json: string): MaterialAssignmentCondition {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a MaterialAssignmentCondition instance
   */
  static fromObject(obj: any): MaterialAssignmentCondition {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to MaterialAssignmentCondition');
    }


    const instance: MaterialAssignmentCondition = {
      fieldName: obj['fieldName'] as MaterialAssignmentIndexedFields | undefined,
      operator: obj['operator'] as ApiPiConditionOperator | undefined,
      value: obj['value'] as any | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of MaterialAssignmentCondition instances
   */
  static deserializeArray(json: string): MaterialAssignmentCondition[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a MaterialAssignmentCondition instance to a JSON string
   */
  static serialize(instance: MaterialAssignmentCondition): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a MaterialAssignmentCondition instance to a plain object
   */
  static toObject(instance: MaterialAssignmentCondition): any {
    return {
      'fieldName': instance.fieldName,
      'operator': instance.operator,
      'value': instance.value,
    };
  }

  /**
   * Serializes an array of MaterialAssignmentCondition instances to a JSON string
   */
  static serializeArray(instances: MaterialAssignmentCondition[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
